import React from 'react';
import EditableInput from '../../common/editableInput/EditableInput';
import CheckBox from '../../common/checkBox/CheckBox';

const NotificationSettings = ({ customer }) => {
  return (
    <div>
      <h5 className="text-xl mb-4 font-medium">Notifications</h5>
      <EditableInput
        inputName="notifications_email"
        inputType="email"
        label="Notification Email"
        value={customer.notifications_email}
        placeholder="Notification Email"
        shouldDisable={true}
        regex={
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        }
        validationMessage="Enter valid email address."
      />
      <div className="mb-4">
        <label className="block mb-2">Opt-in or Opt-out</label>
        <CheckBox
          labelText="Alerts"
          inputName="has_alerts_notifications"
          isChecked={customer.has_alerts_notifications}
        />
        <CheckBox
          labelText="Payment Reminders"
          inputName="has_payment_reminders_notifications"
          isChecked={customer.has_payment_reminders_notifications}
        />
        <CheckBox
          labelText="Newsletter"
          inputName="has_newsletter_notifications"
          isChecked={customer.has_newsletter_notifications}
        />
        <CheckBox
          labelText="Messages"
          inputName="has_messanges_notifications"
          isChecked={customer.has_messanges_notifications}
        />
      </div>
    </div>
  );
};

export default NotificationSettings;
